import React from 'react';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-400 py-12 text-center text-sm" data-id="element-63">
      <div className="max-w-4xl mx-auto px-6" data-id="element-64">
        <p className="mb-4" data-id="element-65">
          © 2026 KIT Recruiter PRO. Todos los derechos reservados.
        </p>
        <p className="text-xs text-slate-500 max-w-2xl mx-auto leading-relaxed" data-id="element-66">
          Este sitio no es parte del sitio web de Facebook o Meta Inc. Además,
          este sitio NO está respaldado por Facebook de ninguna manera.
        </p>
      </div>
    </footer>;
}